/**
 * 오더 핸들 팝업(OrderHandle)의 액션 함수 모음.
 * 레거시 public/js/a-order-edit.js 를 adm.js 번들로 흡수한 것.
 * onclick 인라인에서 호출되므로 전역(window.*)으로 노출한다.
 * 페이지 전역 변수(ordernum, order_info, gps …)는 OrderHandle.setGlobals() 가 세팅.
 */
import Util from '../../../Common/Util';

// function doChangeWorkType(orderno){
//     wwod = orderno;
//     document.getElementById("dateChingTingTop").style.display="block";
// }
window.setTset = function (ty, hr){
    document.getElementById("dd_type").value=ty
    document.getElementById("dd_hr").value=hr;
    var obj = document.getElementById("hr_" + hr + "hr");
    if( ty == "하루") obj = document.getElementById("hr_aday");
    obj.checked= true;

}
window.hrSetTo = function (n){
    document.getElementById("dd_hr").value=n;
}
// function dtyhrsetGo(){
//     var dd_type = document.getElementById("dd_type").value;
//     var dd_hr = document.getElementById("dd_hr").value;
//     if( dd_type == "" || dd_hr  == "") { alert("구분/ 시간 을 선택해 주세요!"); return;}
//     var orderno = ordernum;
//     if( orderno < 10 ){alert("오더번호 에러");return;}
//     var dd_hr_show = dd_hr + " 시간";
//     if( dd_type == "하루") dd_hr_show = dd_hr + " 일";
//     var mg = "현재 오더 작업구분을\n "+ dd_type + "(" + dd_hr_show + ")로 설정할까요?";
//     if (! confirm(mg)) return;
//     var adr = "__ajax_retun_value_pc.php";
//     var sendData = {"jobtype":"order_workType_hrchange", "ordernum":orderno, "dd_worktype" :dd_type , "dd_workhr":dd_hr};
//     console.log( sendData );
//     $.ajax({type:"POST", url:adr , data:sendData , success:function(data){
//             var data = JSON.parse(data);
//             alert('수정완료');
//             document.location.reload();
//         }});
// }
window.applyAddhr = function (n){
    var defP = parseInt(document.getElementById("defaddhrprice").value);
    if( isNaN(defP)) defP = 0;
    if( defP < 10000 ){ alert("기본 추가 금액을 입력해 주세요");document.getElementById("defaddhrprice").focus(); return;}

    document.getElementById("addhrval").value=n;
    document.getElementById("addhrPrice").value= parseInt(n * defP);
}

/**
 * 외부배차 수주자(이름·전화) 입력창 — 외부배차전환과 외부배차정보변경이 같은 창을 쓴다.
 * 대상 판정은 서버가 한다 (OrderPolicyService::outBaeBlockReason / outBaeEditBlockReason).
 * 화면이 들고 있는 order_type·order_status 는 렌더 시점 스냅샷이라, 여기서 미리 막으면
 * 오더관리를 띄워둔 사이에 붙은 수주를 놓친다.
 */
function openOuterWorkerDialog(opt){
    const esc = (v) => String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    const read = () => ({
        name:  String($('#oh-outer-name').val() || '').trim(),
        phone: String($('#oh-outer-phone').val() || '').trim(),
    });

    $j.Ui.Dialog.open({
        tone:  opt.tone,
        width: '380px',
        title: opt.title,
        desc:  opt.desc,
        htmlAfter: `<div class="oh-dlg-form">
            <label class="ui-dlg-inlabel" for="oh-outer-name">작업자 이름</label>
            <input id="oh-outer-name" class="ui-dlg-input" type="text" value="${esc(opt.name)}">
            <label class="ui-dlg-inlabel" for="oh-outer-phone">작업자 전화</label>
            <input id="oh-outer-phone" class="ui-dlg-input" type="tel" value="${esc($j.Common.Util.phoneNumber(String(opt.phone || '')))}">
        </div>`,
        confirm: opt.confirm,
        cancel:  '닫기',
        validate: () => {
            const v = read();
            return (!v.name || v.phone.replace(/\D/g, '').length < 10) ? '작업자 이름과 전화번호를 입력해 주세요.' : '';
        },
        onConfirm: () => {
            const v = read();
            $.ajax({
                type: 'POST',
                url:  `/adm/ajax/order/${window.ordernum}/${opt.seg}`,
                data: opt.data(v),
                success: function (data){
                    if( !data || data.result === false ){ Util.swalert([(data && data.message) || '처리하지 못했습니다.', 'warning']); return; }
                    Util.swalert([data.message || '처리했습니다.', 'success'], () => location.reload());
                }
            });
        },
        onOpen: () => {
            // 전화칸 — 칠 때마다 대시를 붙인다 (공용 포맷터: 02·050 안심번호 자리수까지 맞춘다)
            $j.Common.Form.registerPhoneHandler('oh-outer-phone');
            const el = document.getElementById('oh-outer-name'); if(el) el.focus();
        },
    });
}

// 외부배차전환(임의발주) — 회원이 아닌 기사에게 배차한다. 수주여부·홀드 잔여는 서버(OrderDispatchService::sendOtherByAdmin)가 막는다.
window.open_outBaecha = function (){
    openOuterWorkerDialog({
        tone:    'warn',
        title:   '외부배차전환',
        desc:    '이 오더를 회원이 아닌 기사에게 배차(임의발주)하고 곧바로 작업완료로 처리합니다.',
        confirm: '외부배차전환',
        seg:     'sendOther',
        data:    (v) => ({ typech_workerName: v.name, typech_workerPhone: v.phone }),
    });
}

// 외부배차정보변경 — 이미 외부배차된 오더의 수주자 이름·전화만 고친다 (OrderModificationService::changeOuterWorker).
window.open_outWorkerEdit = function (){
    openOuterWorkerDialog({
        tone:    'info',
        title:   '외부배차정보변경',
        desc:    '외부배차 수주자의 이름·전화번호를 바꿉니다. 오더 상태는 그대로입니다.',
        confirm: '저장',
        seg:     'outer-worker',
        name:    order_info.driver_name,
        phone:   order_info.driver_phone,
        data:    (v) => ({ worker_name: v.name, worker_directphone: v.phone }),
    });
}

window.callback_applyzip = function (){
    $('#mappos_loc1_last').val($('#mappos_loc1').val());
    $('#mappos_loc2_last').val($('#mappos_loc2').val());
    //$('#editaddress').val($('#inputadr').val());
    var tval = $('#showAddressvalue').val() + " " + $('#inputadr').val();
    $('#editaddress').val(tval.trim());

    $('#default_gps_position').val( $('#mappos_loc1').val() + "," + $('#mappos_loc2').val() );
    zipserchWinJob(-1)
}
window.showAreaMap = function (){
    $("#inputadr").val( eaoinfo_order_address );
    zipserchWinJob(1);
    serchaddr_google(1);
    //document.getElementById('addrserch').style.display='block';
    //alert(document.getElementById('addrserch').style.display);
}

/**
 * 우측영역 화면을 교체한다.
 * @param f (1: 수정폼, 0:정보폼 )
 */
// function toggleRightPanel(f){
//     if( f ){
//         $('#moreorderdiv').hide();
//         $('#jobinfoshowdef').hide();
//         $('#moreorderdiv_in').hide();
//         $('#memoinputmore').show();
//     }
//     else{
//         $('#moreorderdiv').show();
//         $('#jobinfoshowdef').show();
//         $('#moreorderdiv_in').show();
//         $('#memoinputmore').hide();
//     }
// }


window.make_string_Option = function (){
    var tar = document.getElementById("editcar_option");
    var vals = "";
    if( oderoption.length > 0 ) vals = oderoption.toString();
    tar.value = vals
}



window.editrunitCheck = function (){
}
window.edit_reorderThis = function (){
    var a = window;
    var pw = a.window.innerWidth;
    var ph = a.window.innerHeight;
    var ph = a.window.innerHeight;
    var a1 = ((pw/2) - (300/2));
    var a2 = (ph - 480);
    var taR = document.getElementById("Popmessageshow");
    taR.style.left = a1 + "px";
    taR.style.top = a2 + "px";

    taR.style.display="block";
}
// (제거) jobMgreSet / work_memo_do — 관리자 작업메모편집 흐름. work_memo_do 는 호출처가 없어 편집박스가
// 열린 적 없고, jobMgreSet 은 이 저장소에 존재한 적 없는 __called_from_app.php 로 submit 하던 dead 코드.
// (workInfoEditBox·multiuseForm 렌더도 OrderHandle.js 에서 함께 제거.)

/**
 * 작업완료 또는 수금완료 처리
 */
window.jobDOneSet = function (){
    var obj =document.getElementById("joboptchanger");
    var n = obj.value;
    n = parseInt(n,10);
    if( n != 8 && n != 9 ) {alert("작업구분알림");return;}

    var workmoden = n;

    if( workmoden == 8){
        var mtitle = "작업종료"
        var msgg = "[장비불러] 작업종료 내용이 있습니다.<br>"
        msgg += "작업종료<br>";
        msgg += eaoinfo_order_address;
        var mOK_Msg = "발주자에게 작업종료를 통지했습니다.";
        var adr = `/adm/ajax/order/${ordernum}/done`;
        $.ajax({type:"POST", url:adr , success:function(data){
            $j.Ui.JBModal.close('oh-workdone-modal');
            Util.swalert(['처리되었습니다.','success'], ()=> location.reload());
        }});
    }else{
        var mtitle = "수금완료"
        var msgg = "[장비불러] 수금완료 내용이 있습니다.<br>"
        msgg += "수금완료<br>";
        msgg += eaoinfo_order_address;
        var mOK_Msg = "발주자에게 수금완료를 통지했습니다.";
        var adr = `/adm/ajax/order/${ordernum}/pay-done`;
        const data = {};
        const send = () => $.ajax({type:"POST", url:adr , data, success:function(res){
            // 카드결제 결과 확인 중인 오더 — 한 번 묻고, 확인하면 그대로 수금완료한다 (CardOrderService::pendingNotice)
            if (res && res.confirm) {
                Util.swalert(res.message, () => { data.card_pending_ok = 1; send(); }, ['수금완료', '취소']);
                return;
            }
            if (res && res.result === false) { Util.swalert(res.message || '처리하지 못했습니다.'); return; }
            $j.Ui.JBModal.close('oh-workdone-modal');
            Util.swalert(['처리되었습니다.','success'], ()=> location.reload());
        }});
        send();
    }
}

/**
 * 오더의 상태를 변경한다.
 */
window.checkJobChangers = function (){
    var obj =document.getElementById("joboptchanger");
    var n = obj.value;
    n = parseInt(n,10);
    if( order_status == n){
        if ( !confirm("현재 상태와 바꾸려는 상태가 같습니다. 다시 설정할까요?")){return}
    }
    console.log("NNN : " + n + "/ " + ordernum );
    if( n < order_status && order_status != 99  &&  n != 6  ){ alert("상태를 이전으로 돌리려면 작업 취소를 해 주세요.."); return;}
    if( n==6  ){
        changestatusto(ordernum,6,order_status);
        var adr = "/batch.cash.php?detailshow=y&jobact=adminmain&ordernum=" + ordernum;
        var pp = window.open(adr, 'cash_check_hode_both_auto', 'width=650,height=440,scrollbars=yes');
        return;
    }
    if( n==7){
        if ( !confirm("현재 상태를 현장 도착으로 설정할까요?")){return}
        var adr = `/adm/ajax/order/${ordernum}/arrive`;
        $.ajax({type:"POST", url:adr , success:function(data){
            if( data && data.result === false ){ Util.swalert([data.message, 'warning']); return; }
            location.reload();
        }});
    }
    if( order_status==99){
        if ( !confirm("취소 오더입니다 상태를 변경할까요?")){return}
    }
    // var memLogindummy =document.getElementById("memLogindummy");
    // memLogindummy.src=dummy_url;

    // 작업완료(8)/수금완료(9) — 확인 모달
    if( n != 8 && n != 9 ) return;

    var modalTitle = (n==9) ? '수금완료' : '작업완료';
    $j.Ui.JBModal.html('oh-workdone-modal', $j.p.workDoneBox(n), modalTitle, {width:'420px'});
}

window.pc_work_done_infos_Btn_cancel = function (){
    $j.Ui.JBModal.close('oh-workdone-modal');
}


/**
 * 배차완료 전환
 * @param orderNum
 * @param changeTo
 * @param nowStatus
 */
window.changestatusto = function (orderNum,changeTo,nowStatus) {
    var snt = parseInt(nowStatus, 10);
    var onum = parseInt(orderNum, 10);
    if (isNaN(snt)) {
        alert("현재 상태값이 없습니다.");
        return;
    }
    if (isNaN(onum) || onum < 2) {
        alert("오더 번호값이 없습니다.");
        return;
    }
    if (isNaN(snt) > 6) {
        alert("상태값이 배차완료보다 큽니다.");
        return;
    }
    if (nowStatus < 4) {
        if (confirm("현재 오더를 배차 완료로 설정할까요?")) {
            // document.location.href="__called_from_app.php?calltype=adminordernumStatusChangeto_assinedOK&ordernum=" + orderNum;
            let adr = `/adm/ajax/order/${orderNum}/soojoo`;
            $.ajax({
                type: "POST", url: adr, dataType: 'json', success: function (v) {
                    // 1:수주가능, 0:다른기사가이미수주,-1:회원없음,-3:차량미보유,-4:환원건 있음, -5:중복수주,-6:발주제한,-7:수주제한,-100:캐시부족
                    if (v.ret == 1) {
                        alert('처리완료');
                        document.location.reload();
                    } else alert(v.msg);
                }
            });
        }
    } else {
        alert("상태값 전달인자 없음");
        return;
    }
}
// 3분대기 -> 어플 전환
window.waitToApp = function (ordernum){
    if (confirm("3분대기 -> 어플 전환할까요?")) {
        let adr = `/adm/ajax/order/${ordernum}/wait-to-app`;
        $.ajax({
            type: "POST", url: adr, success: function (v) {
                document.location.reload();
            }
        });
    }
}
window.more_order_done = function (n){
    document.getElementById("moreorderdiv").style.display="none";
    var xx = parseInt(n);
    if (! isNaN(n)){
        document.location.href="/adm/order/handle?ordernum=" + n;
    }
}

window.settypeval = function (n){
    $("#order_personselect").val(n);
    document.getElementById("order_personselectholder").style.display="none";
    do_order_now();
}

/**
 * 회원 모바일 발주페이지를 띄운다.
 */
window.do_order_now = function (){
    var order_memNum = $("#order_personselect").val() ;
    if( order_memNum.length < 1 ) { alert("발주할 기사를 먼저 선택해 주세요"); return;}

    $j.F.Admin.Util.userBal(order_memNum);
}

/**
 * 추가 배차 버튼클릭시
 */
window.more_order_show = function (){
    $j.F.Admin.Util.userOrder(order_member_num_val, ordernum,'추가배차');
    //
    // document.getElementById("memoinputmore").style.display="none";
    //
    // var kk = parseInt(ordernum);
    // var ss = parseInt(order_member_num_val);
    // console.log( kk );
    // console.log( ss );
    //
    // if( ! isNaN(kk) && kk > 0 && ! isNaN(ss) && ss > 0  ){
    //     console.log("AAAA");
    //     var objx = document.getElementById("order_personselectholder");
    //     var inval = "<select id='order_personselect' name='order_personselect' onchange='do_order_now()' style='height:30px;width:400px;'>";
    //     inval += "<option value='" + ss + "'>" + ss + "</option></select>";
    //     objx.innerHTML = inval;
    //     document.getElementById("moreorderdiv").style.display="block";
    //     document.getElementById("jobinfoshowdef").style.display="none";
    //     document.getElementById("moreorderdiv_in").style.display="block";
    //     do_order_now();
    // }else{
    //     console.log("BBBB");
    //     document.getElementById("moreorderdiv").style.display="block";
    //     document.getElementById("moreorderdiv_in").style.display="block";
    //     document.getElementById("jobinfoshowdef").style.display="none";
    // }
}


window.parent_reload = function (){
    //window.opener.document.location.reload();
}
window.cancel_order = function (){
}

window.re_sendOrder = function (){
    Util.swalert(["매칭알림을 그대로 한 번 더 보낼까요? \n매칭된 전원이 한꺼번에 받고, 상태·차수는 그대로입니다.",'question'],()=>{
        $.ajax({
            type: 'POST',
            url: `/adm/ajax/order/${ordernum}/re-push`,
            success: function (r) {
                if (!r || !r.result) {
                    Util.swalert([(r && r.message) || '처리하지 못했습니다.', 'warning']);
                    return;
                }
                Util.swalert([r.message, 'success'], function () {
                    document.location.href = `/adm/order/handle?ordernum=${ordernum}`;
                });
            }
        });
    });
}
/**
 * 금액변경 — 공용 확인창($j.Ui.Dialog). 초기값·저단가 하한은 GET /adm/ajax/order/{n}/price/form.
 * 스카이 저단가 하한 아래로 내리면 발주자의 -6차·발주개수가 끊긴다 (2026-09-01~).
 * 관리자는 대리로 고치는 자리라 잃는 사람이 자기가 아니다 — 그래서 한 번 더 묻는다.
 */
window.price_form = function (ordernum){
    const digits = (v) => parseInt(String(v || '').replace(/\D/g, ''), 10) || 0;
    const won = (n) => `${n.toLocaleString()}원`;

    $.getJSON(`/adm/ajax/order/${ordernum}/price/form`, function (s){
        if( !s || !s.result ){ Util.swalert([(s && s.message) || '데이터를 불러오지 못했습니다.', 'warning']); return; }

        // 본사가 장비불러면 협력사 금액칸이 없다 — 그때는 지금 값을 그대로 보낸다
        const read = () => ({
            price: digits($('#oh-price').val()),
            bonsa: s.edit_bonsa ? digits($('#oh-price-bonsa').val()) : s.car_price_bonsa,
        });
        const send = (v) => $.ajax({
            type: 'post',
            url:  `/adm/ajax/order/${ordernum}/price`,
            data: { changeprice: v.price, changeprice_bonsa: v.bonsa },
            dataType: 'json',
            success: function (data){
                if( !data.result ){ Util.swalert([data.message || '변경하지 못했습니다.', 'warning']); return; }
                Util.swalert(['변경되었습니다.', 'success'], () => location.reload());
            },
            error: function (){ Util.swalert(['요청 처리중 오류가 발생했습니다.', 'warning']); },
        });

        $j.Ui.Dialog.open({
            tone:  'info',
            width: '380px',
            title: '금액변경',
            htmlAfter: `<div class="oh-dlg-form">
                <label class="ui-dlg-inlabel" for="oh-price">${s.edit_bonsa ? '금액 (장비불러)' : '금액'}</label>
                <input id="oh-price" class="ui-dlg-input" type="text" inputmode="numeric" data-amount-kor value="${s.car_price.toLocaleString()}">
                ${s.edit_bonsa ? `
                <label class="ui-dlg-inlabel" for="oh-price-bonsa">금액 (협력사)</label>
                <input id="oh-price-bonsa" class="ui-dlg-input" type="text" inputmode="numeric" data-amount-kor value="${s.car_price_bonsa.toLocaleString()}">` : ''}
            </div>`,
            confirm: '변경',
            cancel:  '닫기',
            validate: () => {
                const v = read();
                if( !v.price ) return '금액을 입력해 주세요.';
                return (v.price === s.car_price && v.bonsa === s.car_price_bonsa) ? '현재 금액과 같습니다.' : '';
            },
            onConfirm: () => {
                const v = read();
                const limit = parseInt(s.sky_low_limit || 0, 10);
                if( !(limit && v.price < limit) ){
                    // 저단가였다가 벗어나면 해제를 알린다 — 말없이 바뀌면 -6차가 되살아난 줄 모른다
                    if( !parseInt(s.sky_low_now || 0, 10) ){ send(v); return; }
                    const done = parseInt(s.order_status || 0, 10) >= 8;
                    setTimeout(() => $j.Ui.Dialog.open({
                        tone:  'success',
                        title: '저단가가 해제됩니다',
                        desc:  '이 금액으로 바꾸면 발주자에게',
                        emph:  done ? '-6차 · 발주개수가 지금 지급됩니다' : '-6차 · 발주개수가 다시 지급됩니다',
                        rows: [
                            { k: '변경 금액',   v: won(v.price), tone: 'success' },
                            { k: '저단가 하한', v: won(limit) },
                            ...(parseInt(s.sky_low_fee_on || 0, 10) ? [{ k: '수수료', v: '없음 → 있음' }] : []),
                        ],
                        hint:    '발주자에게 알림이 전송됩니다.',
                        confirm: '변경',
                        cancel:  '취소',
                        onConfirm: () => send(v),
                    }), 0);
                    return;
                }

                // 입력창이 닫힌 뒤에 띄운다 — 겹치면 어느 창의 버튼인지 헷갈린다
                setTimeout(() => $j.Ui.Dialog.open({
                    tone:  'danger',
                    title: '저단가로 변경됩니다',
                    desc:  '이 금액으로 바꾸면 발주자에게',
                    emph:  '-6차 · 발주개수가 지급되지 않습니다',
                    rows: [
                        { k: '변경 금액',   v: won(v.price), tone: 'danger' },
                        { k: '저단가 하한', v: won(limit) },
                        // 수수료도 정책이 함께 내린다(changePrice). 발주자가 직접 고른 수수료없음은
                        // 건드리지 않으므로 달라지는 오더에만 이 줄이 선다 — 서버가 판정해 내려준다.
                        ...(parseInt(s.sky_low_fee_off || 0, 10) ? [{ k: '수수료', v: '있음 → 없음' }] : []),
                    ],
                    confirm: '변경',
                    cancel:  '취소',
                    onConfirm: () => send(v),
                }), 0);
            },
            onOpen: () => {
                // 치는 대로 천단위 콤마
                $('#oh-price, #oh-price-bonsa').on('input', function (){
                    const n = digits(this.value);
                    this.value = n ? n.toLocaleString() : '';
                });
                const el = document.getElementById('oh-price'); if(el){ el.focus(); el.select(); }
            },
        });
    }).fail(() => Util.swalert(['데이터를 불러오지 못했습니다.', 'warning']));
}

/**
 * 수수료변경 — 있음 ↔ 없음을 뒤집는다. 무엇으로 바뀌는지는 GET /adm/ajax/order/{n}/fee/form 의 is_fee_target.
 * 실패(캐시부족 -100/-200)면 서버가 모자란 금액을 message 로 준다.
 */
window.fee_form = function (ordernum){
    $.getJSON(`/adm/ajax/order/${ordernum}/fee/form`, function (f){
        if( !f || !f.result ){ Util.swalert([(f && f.message) || '데이터를 불러오지 못했습니다.', 'warning']); return; }

        const toFee = Number(f.is_fee_target) === 1;
        $j.Ui.Dialog.open({
            tone:  'info',
            width: '380px',
            title: '수수료변경',
            rows: [
                { k: '현재',   v: toFee ? '수수료 없음' : '수수료 있음' },
                { k: '변경 후', v: toFee ? '수수료 있음' : '수수료 없음', tone: 'danger' },
            ],
            confirm: '변경',
            cancel:  '닫기',
            onConfirm: () => $.ajax({
                type: 'post',
                url:  `/adm/ajax/order/${ordernum}/fee`,
                data: { is_fee: f.is_fee_target },
                dataType: 'json',
                success: function (data){
                    if( !(data.result >= 0) ){ Util.swalert([data.message || '변경하지 못했습니다.', 'warning']); return; }
                    Util.swalert(['변경되었습니다.', 'success'], () => location.reload());
                },
                error: function (){ Util.swalert(['요청 처리중 오류가 발생했습니다.', 'warning']); },
            }),
        });
    }).fail(() => Util.swalert(['데이터를 불러오지 못했습니다.', 'warning']));
}

window.showMapBig = function (){
    var adr = "/map/full?gps=" + gps;
    var win2=window.open(adr,'mapBigDetail','toolbar=no,status=no,WIDTH=' + screen.width+',HEIGHT=' + screen.height+', directories=no,scrollbars=yes,location=no,resizable=yes,menubar=no');
    win2.focus();
}

window.send_field_arrival_request = function (ordernum,sendernum,recivernum,addressval){
    Util.swalert(['수주자에게 현장도착 요청하시겠습니까','question'],()=>{
        var mOK_Msg = "수주자에게 현장도착 요청을 완료했습니다.";
        $.ajax({type:'POST', url:'/adm/ajax/order/push-request', dataType:'json',
            data:{ordernum:ordernum, notitype:'request_field_arrival'},
            success:function(r){
                if(r.result){ Util.swalert([mOK_Msg,'success'], function(){ notice_donejobdo(); }); }
                else Util.swalert([r.message,'warning']);
            }});
    });
}

window.send_job_done_request = function (ordernum,sendernum,recivernum,addressval){
    Util.swalert(['수주자에게 작업종료 요청하시겠습니까','question'],()=>{
        var mOK_Msg = "수주자에게 작업종료 요청을 완료했습니다.";
        $.ajax({type:'POST', url:'/adm/ajax/order/push-request', dataType:'json',
            data:{ordernum:ordernum, notitype:'request_job_done'},
            success:function(r){
                if(r.result){ Util.swalert([mOK_Msg,'success'], function(){ notice_donejobdo(); }); }
                else Util.swalert([r.message,'warning']);
            }});
    });
}

window.reqest_paymentdone = function (ordernum,sendernum,recivernum,addressval){
    Util.swalert(['수주자에게 수금완료요청하시겠습니까','question'], ()=>{
        var mOK_Msg = "수주자에게 수금완료요청을 완료했습니다.";
        $.ajax({type:'POST', url:'/adm/ajax/order/push-request', dataType:'json',
            data:{ordernum:ordernum, notitype:'payment_done_request'},
            success:function(r){
                if(r.result){ Util.swalert([mOK_Msg,'success'], function(){ notice_donejobdo(); }); }
                else Util.swalert([r.message,'warning']);
            }});
    });
}
// 페널티 취소
window.cancel_penalty = function (ordernum){
    Util.swalert(['페널티 취소하시겠습니까','question'],()=>{
        $.ajax({type:'POST',url:`/adm/ajax/order/${ordernum}/penalty-cancel`,
            success : function (r) {
                // 실패도 200 으로 온다(result 0·음수) — 응답을 안 보면 막힌 요청에 '처리완료' 가 뜬다
                if(!r || !(r.result > 0)) {
                    Util.swalert([(r && r.message) || '처리하지 못했습니다.', 'warning']);
                    return;
                }
                Util.swalert(["처리완료",'success'], function(){
                    location.reload();
                });
            }});
    });
}
// 페널티 적용
window.apply_penalty = function (ordernum){
    Util.swalert(['페널티 적용하시겠습니까','question'],()=>{
        $.ajax({type:'POST',url:`/adm/ajax/order/${ordernum}/penalty-apply`,
            success : function (r) {
                if(!r || !(r.result > 0)) {
                    Util.swalert([(r && r.message) || '처리하지 못했습니다.', 'warning']);
                    return;
                }
                Util.swalert(["처리완료",'success'], function(){
                    location.reload();
                });
            }});
    });
}
// 페널티 해제 — 취소는 그대로 두고 페널티분(포인트 -200·수주자 수수료)만 걷는다
window.revoke_penalty = function (ordernum){
    Util.swalert(['페널티를 해제하시겠습니까? 오더는 취소로 남고, 수주자 포인트 -200 이 돌아가며 수수료가 다시 계산됩니다.','question'],()=>{
        $.ajax({type:'POST',url:`/adm/ajax/order/${ordernum}/penalty-revoke`,
            success : function (r) {
                if(!r || !(r.result > 0)) {
                    Util.swalert([(r && r.message) || '처리하지 못했습니다.', 'warning']);
                    return;
                }
                Util.swalert(["처리완료",'success'], function(){
                    location.reload();
                });
            }});
    });
}
/**
 * 오더 취소 — 상태확인 · 사유입력 · 발주자알림 여부를 **창 하나**에서 받는다.
 *
 * 예전엔 세 번 물었다: 상태확인 확인창 → 브라우저 prompt(사유) → 짧으면 alert.
 * 게다가 확인창의 '취소' 버튼이 **닫기가 아니라 또 다른 취소 실행**(발주자알림 제외)이라,
 * 무를 생각으로 누르면 오더가 취소됐다. 알림 제외는 버튼이 아니라 체크박스로 내렸다.
 */
window.cancel_predo = function (){
    if(!order_info) return;
    window.ordernum = order_info.num;

    $.ajax({type:'GET', url:`/adm/ajax/order/${ordernum}/status-check`, success : function (data) {
        // 머리(아이콘·제목·경고 한 줄)는 가운데, 사실은 표(rows)로, 입력칸은 왼쪽(.oh-dlg-form)
        const rows = [
            { k: '오더번호', v: `#${ordernum}` },
            { k: '현재 상태', v: data.canceled ? '취소됨' : data.statusLabel },
        ];
        const worker = String(order_info.bworker_name || order_info.driver_name || '').trim();
        if( worker ) rows.push({ k: '수주자', v: worker });

        let emph = '';
        if( data.canceled ) emph = '이미 취소된 오더입니다.';
        else if( order_status > 6 ){
            emph = needToRollBack > 0 ? '포인트 결제까지 끝난 오더입니다.' : '작업이 끝난 오더입니다. (포인트 결제 전)';
        }

        $j.Ui.Dialog.open({
            tone:  'danger',
            width: '400px',
            title: '오더취소',
            emph:  emph,
            rows:  rows,
            htmlAfter: `<div class="oh-dlg-form">
                <label class="ui-dlg-inlabel" for="oh-cancel-reason">취소 사유</label>
                <input id="oh-cancel-reason" class="ui-dlg-input" type="text" maxlength="80" placeholder="2자 이상">
                <label class="ui-dlg-check">
                    <input type="checkbox" id="oh-cancel-noalim">
                    발주자에게 취소 알림 보내지 않기
                </label>
            </div>`,
            confirm: '오더취소',
            cancel:  '닫기',
            validate: () => {
                const v = String($('#oh-cancel-reason').val() || '').trim();
                return v.length < 2 ? '취소 사유를 2자 이상 입력해 주세요.' : '';
            },
            onConfirm: () => {
                cancel_orderJobDo(
                    $('#oh-cancel-noalim').is(':checked') ? 1 : 0,
                    String($('#oh-cancel-reason').val() || '').trim()
                );
            },
            onOpen: () => { const el = document.getElementById('oh-cancel-reason'); if(el) el.focus(); },
        });
    }});
}

/**
 * 오더 취소 실행 — 묻는 일은 cancel_predo 가 끝냈다. 여기는 보내기만 한다.
 * @param is_exclude_baljooja 발주자푸시 제외여부 (0|1)
 * @param reason              취소 사유 (2자 이상, 호출부가 이미 검증)
 */
window.cancel_orderJobDo = function (is_exclude_baljooja, reason){
    if(!order_info) return;
    window.ordernum   = order_info.num;
    window.addressval = order_info.site_address;

    // 따옴표는 예전부터 털어 보냈다 — 서버가 바인딩을 쓰므로 안전을 위한 것이 아니라
    // 알림 문구에 그대로 실려 나가는 자리라서다.
    const CancelMg = String(reason || '').replace(/['"]/g, '');
    if( !CancelMg ) return;

    window.CancelType = '관리자 발주취소 완료';

    $.ajax({
        type: 'POST',
        url:  `/adm/ajax/order/${ordernum}/cancel`,
        data: { reason: CancelMg, is_exclude_baljooja },
        success: function (data) {
            if( !data.result ){
                Util.swalert(data.message);
                return;
            }
            if (data.notice) {
                Util.swalert(['오더가 취소되었습니다.', 'success', data.notice], () => location.reload());
                return;
            }
            location.reload();
        }
    });
}

window.notice_donejobdo = function (){
    document.location.reload();
}

window.work_done_infos_Btn_cancel = function (){
    $j.Ui.JBModal.close('oh-workdone-modal');
}

window.put_value_infos = function (datas){
    var s = datas.split("&");
    for (var i=0; i< s.length ;i++ ){
        var chit =  s[i];
        if (chit.length > 1){
            var ea = chit.split("=");
            var ea_hd = ea[0];
            var ea_va = ea[1];
            var eatar = eval("document.workflow." + ea_hd);
            if(eatar){
                eatar.value=ea_va;
            }else{
                //alert(ea_hd + " / " + ea_va);
            }
        }
    }
    //document.workflow.submit();
}



/**
 * 소요시 표시
 * @param obj
 * @param ww
 */
// function worktypeoptions_show(obj,ww){
//     if( typeof(car_worktype) == undefined) car_worktype = null;
//     var tar = document.getElementById("worktypeoptions");
//     var n = obj.value;
//     var tx = "px";
//     var width_w = ww;
//     if(ww==999) { tx = "%"; width_w = 100;}
//     if( typeof(car_worktype) == "string" ){
//         car_worktype = car_worktype.replace("짐짜주기없음,", "");
//     }
//     var cartype = car_type;
//     var op = "<select name='work_howlong'  id='work_howlong' style='width:" + width_w + tx + "'>";
//     if(cartype =="크레인" && ww==999)   op = "<select name='work_howlong'  id='work_howlong' style='width:" + width_w + tx + "'>";
//     if (ww ==9999) {
//         tar = document.getElementById("ex_worktypeoptions");
//         op = "<select name='exwork_howlong'  id='exwork_howlong' style='width:100%;height:30px;border-bottom:white 1px solid;border-top:white 1px solid;border-left:white 1px solid;border-right:white 1px solid;'>";
//     }
//     if (n=="") return;
//     n=n.trim();
//     if(n=="일"){
//         op+="<option value='1' selected>1일</option>";
//         for (var i = 2 ; i < 31 ; i++ ){
//             i < 10 ? dd = "0" + i : dd = i;
//             op+="<option value='" + i + "'>" + dd + "일</option>";
//         }
//     }else if(n=="월"){
//         op+="<option value='1' selected>1월</option>";
//         for (var i = 2 ; i < 7; i++ ){op+="<option value='" + i + "'>" + i + "월</option>"; }
//     }else if (n=="이삿짐" || n=="가구/가전"){
//         var etons = [2.5 ,5,6,7.5,10,12.5,15,17.5,20];
//         op+="<option value='1' selected>1톤</option>";
//         for (var i = 0 ; i < etons.length ; i++){
//             op+="<option value='"+etons[i]+"'>"+etons[i]+"톤</option>";
//         }
//     }else if (n=="오전" || n=="오후"){
//         op+="<option value='4' selected>4시간</option>";
//         op+="<option value='3'>3시간</option>";
//         op+="<option value='2'>2시간</option>";
//         op+="<option value='1'>1시간</option>";
//     }else if (n=="시간"){
//         for (var i = 1 ; i < 25; i++ ){op+="<option value='" + i + "'>" + i +  "시간</option>"; }
//     }else if (n=="야간"){
//         for(let i=1;i<=12;i++){op+="<option value='" + i + "'>" + i +  "시간</option>"; }
//     }
//     op +="</select>";
//     tar.innerHTML = op;
//     workType_moreshow();
//
// }

/**
 * 사다리 추가 옵션
 */
// function workType_moreshow(){
//
//     if(!document.getElementById("worktypeday")) return;
//     var n = $("#worktypeday").val();
//     var tontime = "";
//     var selbe1 = "<select name='worktype' id='worktype' style='width:100%' tabindex='53'><option value=''>작업내용 선택</option><option value='이사 상차'>이사 상차</option><option value='이사 하차'>이사 하차</option><option value='이사 상.하차'>이사상.하차</option><option value='가구/가전'>가구/가전</option></select>";
//     var selbe2 = "<select name='worktype' id='worktype' style='width:100%' tabindex='53'><option value=''>작업내용 선택</option><option value='페기물'>페기물</option><option value='샷시작업'>샷시작업</option><option value='인테리어'>인테리어</option><option value='건축현장'>건축현장</option><option value='기타작업'>기타작업</option></select>"
//
//     var selbTar = document.getElementById("caroptionselble");
//     if(selbTar){
//         if (n=="이삿짐" || n=="가구/가전"){
//             selbTar.innerHTML = selbe1;
//         }else{
//             selbTar.innerHTML = selbe2;
//         }
//     }
//     car_worktype = car_worktype.replace("짐짜주기없음,", "");
//     console.log( "car_worktype : " + car_worktype );
// }

/**
 * 장비유형 리스트 보여주기
 */
// function car_type_listup(){
//     if( !car_type) return;
//     var thisOrder = ordernum;
//     var datas = {"jobtype":"car_type_list","ordernum": thisOrder};
//     $.ajax({type:'POST', dataType:'json', url:"__ajax_retun_value_pc.php", data :datas,success : function (list) {
//         list.forEach((row)=>{
//             let selected = ''; if( row.s ) selected='selected';
//             let option = $("<option value='"+row.ca+"' "+selected+">"+row.ca+"</option>");
//             $('#tonsel').append(option);
//         });
//
//         change_car_type(true);
//     }});
// }

/**
 * 특정 장비유형 선택
 * @param is_order 오더연계여부 1(오더값 참조), 0(오더값 참조안함)
 */
// function change_car_type(is_order){
//     var thisOrder = ordernum;
//     var this_car_type = car_type;
//     if( !is_order) thisOrder=0;
//     var ca = $("#tonsel option:selected").val();
//     var datas = {"jobtype":"car_ton_list","ordernum": thisOrder, "car_type": this_car_type, "ca":ca};
//
//     $('#meter_start').empty();
//     $('#meter_start').append( $("<option value=''>선택</option>") );
//     $('#meter_end').empty();
//     $('#meter_end').append( $("<option value=''>선택</option>") );
//     $.ajax({type:'POST', dataType:'json', url:"__ajax_retun_value_pc.php", data :datas,success : function (out) {
//         let from = out.from;
//         let to = out.to;
//         // let unit = out.unit;
//         from.forEach((row)=>{
//             let selected = ''; if( row.s ) selected='selected';
//             let option = $("<option value='"+row.item+"' "+selected+">"+row.label+"</option>");
//             $('#meter_start').append(option);
//         });
//         to.forEach((row)=>{
//             let selected = ''; if( row.s ) selected='selected';
//             let option = $("<option value='"+row.item+"' "+selected+">"+row.label+"</option>");
//             $('#meter_end').append(option);
//         });
//     }});
// }

window.evtNoticeShow = function (num){
    var adr = "/adm/order/match/list?num=" + num + "&stype=admin";
    // 창 높이를 화면 가용높이로 클램프 — 창이 화면보다 크면 아래가 잘리고 스크롤바가 안 생김
    var w = Math.min(1400, screen.availWidth), h = Math.min(1000, screen.availHeight);
    var win2=window.open(adr,'manage_order_matchList','toolbar=no,status=no,width='+w+',height='+h+',top=0,directories=no,scrollbars=yes,location=no,resizable=yes,menubar=no');
    win2.focus();
}

// 회차
window.makeorderReturn = function (orderno,newprice,oldprice,newprice_bonsa){
    Util.swalert(['회차처리하시겠습니까?','question'],()=>{
        var adr = `/adm/ajax/order/${orderno}/price`;
        $.ajax({
            type:'post',
            url: adr,
            data: {
                'changeprice': newprice,
                'changeprice_bonsa': newprice_bonsa,
                'changemode': 'workdonereturnset'
            },
            dataType: 'json',
            success: function(data){
                var msg = 'OK';
                if( !data.result ) {
                    msg = data.message;
                }
                Util.swalert(msg,()=>{
                    location.reload();
                });
            }
        });
    });

}
/**
 * 취소원복 — 취소 순간의 스냅샷으로 되돌린다. 무엇을 되돌릴지는 서버가 계산한 계획을 그대로 보여준다.
 * 버튼 노출은 서버 판정(actBlocks.restore)이 정하고, 실행 때 서버가 같은 판정으로 다시 막는다.
 */
window.restore_cancel = function (){
    if(!order_info) return;
    const n = order_info.num;
    $.ajax({type:'GET', url:`/adm/ajax/order/${n}/restore/plan`, success: function (p) {
        if(!p || !p.result){ Util.swalert([(p && p.message) || '되돌릴 수 없는 오더입니다.', 'warning']); return; }
        $j.Ui.Dialog.open({
            tone:  'danger',
            align: 'left',
            width: '520px',
            title: '취소원복',
            desc:  `취소된 오더를 취소 직전 상태 [ ${p.targetLabel} ] 로 되살립니다.`,
            emph:  '수주자·발주자의 캐시·포인트·발주개수·-6차가 함께 움직입니다. 실수로 취소한 경우에만 쓰세요.',
            rows:  p.rows || [],
            notes: p.plan,
            htmlAfter: `<input id="oh-restore-memo" class="ui-dlg-input" type="text" maxlength="60" placeholder="메모 (선택 · 오더로그에 남음)">`,
            hint:  (p.warnings || []).join('\n'),
            agree: '위 스냅샷 내용과 되돌릴 항목을 확인했습니다',
            confirm: '되돌리기',
            cancel:  '닫기',
            onConfirm: () => {
                $.ajax({type:'POST', url:`/adm/ajax/order/${n}/restore`,
                    data: { memo: String($('#oh-restore-memo').val() || '').trim() },
                    success: function (r) {
                        if(!r || !r.result){ Util.swalert([(r && r.message) || '되돌리지 못했습니다.', 'warning']); return; }
                        Util.swalert([r.message, 'success'], function(){ location.reload(); });
                    }});
            },
        });
    }});
}
// 환원원복
window.rollbackWhanwon = function (ordernum){
    Util.swalert(['환원원복 처리하시겠습니까?','question'],()=>{
        $.ajax({
            type: 'post',
            url: `/adm/ajax/order/${ordernum}/whanwon/rollback`,
            success: function(data){
                Util.swalert('처리했습니다.',()=>{
                    location.reload();
                });
            }
        });
    });
}
// 환원보류 — 사유입력 모달 열기/닫기 (n=-1 이면 닫기). 모달 HTML은 OrderHandle.whanDeferBox() 가 그린다.
window.make_whanDeferBox = function (n){
    var obj = document.getElementById("whanDeferBox");
    if( n == -1 ){
        obj.style.display = "none";
    }else{
        document.getElementById("whanDefer_memo").value = '';
        updateWhanDeferMemoCount();
        obj.style.display = "block";
    }
}
// 환원보류 사유 글자수 표시 — 오더메모 편집칸(.oh-editable__count)과 같은 배지를 쓴다. DB(g5_order_logs.rel_desc)가 varchar(80)이라 80자 고정.
window.updateWhanDeferMemoCount = function (){
    var len = document.getElementById("whanDefer_memo").value.length;
    var $count = document.getElementById("whanDefer_memo_count");
    $count.textContent = len + '/80';
    $count.classList.toggle('is-full', len >= 80);
}
// 환원보류 저장 — 사유 필수. 이번 환원배치 대상에서 제외된다.
window.save_whanDefer = function (){
    var ordernum = document.getElementById("whanDefer_ordernum").value;
    var memo = document.getElementById("whanDefer_memo").value.trim();
    if( !memo ){ alert("환원보류 사유를 입력해 주세요"); return; }

    $.ajax({
        type: 'post',
        url: `/adm/ajax/order/${ordernum}/whanwon/defer`,
        data: { memo: memo },
        success: function(data){
            if( !data.result ){ alert(data.message || '처리에 실패했습니다.'); return; }
            make_whanDeferBox(-1);
            Util.swalert('처리했습니다.',()=>{
                location.reload();
            });
        }
    });
}
// 환원처리(수금완료 → 환원) — 사유입력 모달 열기/닫기 (n=-1 이면 닫기).
// 모달 HTML은 OrderHandle.whanRevertBox() 가 그린다. 버튼 노출조건은 서버(D.whanRevertable) 몫.
window.make_whanRevertBox = function (n){
    var obj = document.getElementById("whanRevertBox");
    if( n == -1 ){
        obj.style.display = "none";
    }else{
        document.getElementById("whanRevert_memo").value = '';
        updateWhanRevertMemoCount();
        obj.style.display = "block";
    }
}
// 환원 사유 글자수 표시 — 환원보류와 같은 배지. DB(g5_order_logs.rel_desc)가 varchar(80)이라 80자 고정.
window.updateWhanRevertMemoCount = function (){
    var len = document.getElementById("whanRevert_memo").value.length;
    var $count = document.getElementById("whanRevert_memo_count");
    $count.textContent = len + '/80';
    $count.classList.toggle('is-full', len >= 80);
}
/**
 * 환원처리 저장 — 사유 필수. 수금완료를 취소하고 곧바로 환원(페널티·포인트차감)까지 확정한다.
 *
 * 확인창을 한 번 더 띄우지 않는다. 확인 단계는 이 모달 자체가 이미 하고 있다 —
 * 결과를 적은 경고문 + 사유를 손으로 쳐야 하는 필수칸 + 빨간 버튼 (환원보류와 같은 방식).
 */
window.save_whanRevert = function (){
    var ordernum = document.getElementById("whanRevert_ordernum").value;
    var memo = document.getElementById("whanRevert_memo").value.trim();
    if( !memo ){ alert("환원 사유를 입력해 주세요"); return; }

    $.ajax({
        type: 'post',
        url: `/adm/ajax/order/${ordernum}/whanwon/revert`,
        data: { memo: memo },
        success: function(data){
            if( !data.result ){ alert(data.message || '처리에 실패했습니다.'); return; }
            make_whanRevertBox(-1);
            Util.swalert('환원처리 했습니다.',()=>{
                location.reload();
            });
        }
    });
}
// 환원보류해제 — 다음 환원배치부터 다시 대상에 포함
window.releaseWhanDefer = function (ordernum){
    Util.swalert(['환원보류를 해제하시겠습니까? (다음 환원배치부터 다시 대상에 포함됩니다)','question'],()=>{
        $.ajax({
            type: 'post',
            url: `/adm/ajax/order/${ordernum}/whanwon/defer-release`,
            success: function(data){
                Util.swalert('처리했습니다.',()=>{
                    location.reload();
                });
            }
        });
    });
}

/**
 * 오더수정+재발주 하기전에 체크
 * @param n
 */
window.saveChangeorderInfo_ready = function (n){
    var thisOrder = ordernum;
    $.ajax({type:'GET',url:"/adm/ajax/order/" + thisOrder + "/status-check", success : function (data) {
            // 수주자 있는 오더(배차완료 이후)는 수정 재발주 불가 (취소/저장만 예외)
            if( !data.canceled && data.hasWorker && n != "Cancelgo" && n != "saveonly" ){
                alert("이미 수주자가 있는 오더입니다. 수정 재발주 할 수 없습니다.");
                return;
            }
            var dda = data.canceled
                ? "이 오더는 취소된 오더 입니다. 진행할까요?"
                : "이 오더는 현재 [ " + data.statusLabel + " ] 상태 입니다.  진행 할까요?";
            saveChangeorderInfo(n,dda);
        }});
}

let origin_datas = {};
/**
 * 클릭하면 편집할수있게
 */
window.edit_fn = function (){
    // 줄바꿈이 값의 일부인 셀(.oh-editable--multiline, 예: 작업내용)은 엔터로 줄을 나눌 수 있다.
    // 그런 셀은 브라우저가 개행을 <br>/<div> 로 넣으므로 text() 가 아니라 innerText 로 읽어야 한다.
    const MULTILINE_MAX_LINES = 2;
    const readCell = (el) => el.hasClass('oh-editable--multiline')
        ? el[0].innerText.replace(/\n+$/, '')   // contenteditable 이 붙이는 후행 개행 제거
        : el.text();

    // 글자수 한도(data-maxlen)가 걸린 셀 — contenteditable 은 maxlength 가 없어 직접 막는다
    const maxLenOf = (el) => parseInt(el.attr('data-maxlen'), 10) || 0;
    const warnMaxLen = (max) => {
        // 타이핑마다 뜨지 않게 — 이미 떠 있으면 건너뛴다 (구 Swal.isVisible() 자리)
        if( $('.ui-dlg-panel').length ) return;
        $j.Ui.Dialog.open({
            tone:    'warn',
            title:   `작업내용은 ${max}자까지 입력할 수 있습니다`,
            confirm: '확인',
        });
    };

    $(".editor").click(function(){
        var el = $(this);
        console.log('click -> ' + el.attr('contenteditable') ) ;
        if( el.attr('contenteditable')=='true' ) return;

        const col = el.attr('data-value');// 오더테이블의 컬럼명
        origin_datas[ col ] = readCell(el);// 원래값 보관
        el.attr('contenteditable','true');
        el.css('background-color','white');
        const maxLen = maxLenOf(el);

        // 한도가 있는 셀은 편집하는 동안 글자수를 보여준다 (12/66).
        // 칸 바로 아래에 뜨는 작은 토스트다 — 칸 안에 넣으면 contenteditable 의 값에 섞인다.
        let $count = null;
        const drawCount = () => {
            if( !$count ) return;
            const len = readCell(el).length;
            $count.text(`${len}/${maxLen}`).toggleClass('is-full', len >= maxLen);
        };
        if( maxLen ){
            $count = $('<div class="oh-editable__count"></div>');
            $count.insertAfter(el);
            drawCount();
            el.on('input', drawCount);
        }

        el.keypress(function(e){
            if(e.which!==13){
                // 한도에 닿았으면 더 받지 않는다 (선택영역을 덮어쓰는 입력은 길이가 늘지 않으므로 제외)
                const selLen = String(window.getSelection() || '').length;
                if( maxLen && readCell(el).length - selLen >= maxLen ){
                    e.preventDefault();
                    warnMaxLen(maxLen);
                }
                return;
            }
            if( el.hasClass('oh-editable--multiline') ){
                // 정해진 줄수까지만 엔터를 받는다 (서버 clampWorkContent 도 같은 기준)
                if( readCell(el).split('\n').length >= MULTILINE_MAX_LINES ) e.preventDefault();
                return;
            }
            e.preventDefault();
            el.blur();
            el.off('keypress');
        });
        // 붙여넣기는 keypress 를 타지 않는다 — 넣은 뒤 잘라낸다
        el.on('paste', function(){
            if( !maxLen ) return;
            setTimeout(function(){
                const v = readCell(el);
                if( v.length > maxLen ){ el.text(v.substring(0, maxLen)); warnMaxLen(maxLen); }
                drawCount();
            }, 0);
        });
        el.blur( function(){
            el.attr('contenteditable','false');
            el.css('background-color','');
            //el.removeClass('editon');
            console.log('blur'+ Math.random().toString(36));
            let now = readCell(el);
            if( maxLen && now.length > maxLen ){// IME 조합 등으로 한도를 넘겼다면 마지막에 자른다
                now = now.substring(0, maxLen);
                el.text(now);
                warnMaxLen(maxLen);
            }
            if( origin_datas[ col ] != now ){// 변경되었다면
                edit_save(col, now); // 저장하자.
            }
            if( $count ){ $count.remove(); $count = null; el.off('input'); }
            el.off('blur').off('paste');
        });
    });
}
// 서버에 저장하자.
window.edit_save = function (col,memo){
    $.ajax({
        type: "POST",
        url: `/adm/ajax/order/${ordernum}/memos`,
        data: {'col': col, 'memo': memo},
        dataType: 'JSON',
        success: (data) => {
        }
    });
}